import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default React.memo(props => (
  <SvgIcon
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18.9789 5.31353C18.7628 4.51027 18.1295 3.87707 17.3264 3.66077C15.8591 3.25932 9.99001 3.25932 9.99001 3.25932C9.99001 3.25932 4.12113 3.25932 2.65388 3.64555C1.86619 3.86162 1.21742 4.51038 1.00136 5.31353C0.615234 6.78066 0.615234 9.8233 0.615234 9.8233C0.615234 9.8233 0.615234 12.8813 1.00136 14.3331C1.21765 15.1362 1.85074 15.7694 2.654 15.9857C4.13658 16.3873 9.99023 16.3873 9.99023 16.3873C9.99023 16.3873 15.8591 16.3873 17.3264 16.0011C18.1296 15.7849 18.7628 15.1517 18.9791 14.3485C19.3651 12.8813 19.3651 9.83875 19.3651 9.83875C19.3651 9.83875 19.3806 6.78066 18.9789 5.31353ZM8.12141 12.6342V7.01241L13.0019 9.8233L8.12141 12.6342Z"
      fill="currentColor"
    />
  </SvgIcon>
));
